import styles from './BusinessProfileMain.module.css';
import GeneralInformation from './sections/GeneralInformation';
import BusinessProfileConfiguration from './sections/BusinessProfileConfiguration';
import BusinessPhysicalAddress from './sections/BusinessPhysicalAddress';
import ClientSuccessFactors from './sections/ClientSuccessFactors';

const BusinessProfileMain = () => {
  return (
    <div className={styles.businessProfileContainer}>
      {/* Left section */}
      <div className={styles.leftSection}>
        <GeneralInformation />
        <BusinessProfileConfiguration />
      </div>
      
      {/* Right section */}
      <div className={styles.rightSection}>
        <BusinessPhysicalAddress />
        <ClientSuccessFactors />
      </div>
    </div>
  );
};

export default BusinessProfileMain;